import { Link } from "react-router-dom";
import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import { dentistReportRows } from "@/mocks/dentists";
import { site } from "@/mocks/site";

const partnerWhatsapp = `${site.whatsappBase}${encodeURIComponent(
  "Diş hekimi olarak görüntüleme iş ortaklığı hakkında bilgi almak istiyorum.",
)}`;

export default function DentistHero() {
  return (
    <section className="relative overflow-hidden bg-primary-950 pt-28 md:pt-36">
      <div className="pointer-events-none absolute inset-0 grid-paper opacity-[0.12]" aria-hidden="true" />
      <div
        className="pointer-events-none absolute -right-24 -top-28 h-96 w-96 rounded-full bg-primary-800/50 blur-3xl"
        aria-hidden="true"
      />

      <div
        className="pointer-events-none absolute left-5 top-24 hidden h-12 w-12 rounded-tl-lg border-l border-t border-accent-400/30 lg:block"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute bottom-14 right-6 hidden h-12 w-12 rounded-br-lg border-b border-r border-accent-400/30 lg:block"
        aria-hidden="true"
      />

      <div className="shell relative pb-14 md:pb-20">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-6">
            <Reveal>
              <nav
                aria-label="Sayfa yolu"
                className="flex flex-wrap items-center gap-2 text-xs font-medium text-background-200/70"
              >
                <Link to="/" className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300">
                  Anasayfa
                </Link>
                <i className="ri-arrow-right-s-line text-sm" aria-hidden="true" />
                <span className="whitespace-nowrap text-background-100">Diş Hekimleri</span>
              </nav>
            </Reveal>

            <Reveal delay={70}>
              <span className="mt-7 inline-flex items-center gap-2 rounded-full border border-background-50/25 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-accent-300">
                <i className="ri-team-line text-sm" aria-hidden="true" />
                B2B · Klinikler için iş ortağı
              </span>
            </Reveal>

            <Reveal delay={120}>
              <h1 className="mt-6 font-heading text-3xl font-medium leading-[1.08] tracking-tight text-background-50 md:text-5xl">
                Diş Hekimleri İçin Görüntüleme Partneri
              </h1>
            </Reveal>

            <Reveal delay={170}>
              <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-200/85 md:text-base">
                Hastalarınızı bize yönlendirin; aynı gün dijital rapor ve görüntüleri kliniğinize
                teslim edelim. Panoramik, CBCT, sefalometrik, TME ve periapikal — tüm dental radyoloji
                hizmetleri tek merkezde.
              </p>
            </Reveal>

            <Reveal delay={220}>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Button href={partnerWhatsapp} external variant="accent" size="lg" icon="ri-whatsapp-line">
                  İş Birliği İçin Yazın
                </Button>
                <Button href={site.phoneMainHref} variant="outlineLight" size="lg" icon="ri-phone-line">
                  Telefonla Bilgi Alın
                </Button>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={200}>
              <div className="rounded-xl border border-background-50/15 bg-background-50/95 p-3 md:p-4">
                <div className="mb-3 flex items-center gap-2">
                  <span className="h-2.5 w-2.5 rounded-full bg-secondary-400" aria-hidden="true" />
                  <span className="h-2.5 w-2.5 rounded-full bg-accent-400" aria-hidden="true" />
                  <span className="h-2.5 w-2.5 rounded-full bg-primary-400" aria-hidden="true" />
                  <span className="ml-2 text-xs font-medium text-foreground-500">dmar.com.tr/panel</span>
                </div>

                <div className="flex items-center justify-between border-b border-background-200 px-1 pb-3">
                  <span className="flex items-center gap-2 font-heading text-sm font-medium text-foreground-950">
                    <i className="ri-file-list-3-line text-base text-primary-600" aria-hidden="true" />
                    Rapor Paneli
                  </span>
                  <span className="text-xs font-semibold text-foreground-600">Dr. A. Yılmaz</span>
                </div>

                <ul className="divide-y divide-background-200">
                  {dentistReportRows.map((row) => (
                    <li key={row.name} className="flex items-center gap-3 px-1 py-3">
                      <i className="ri-checkbox-circle-fill text-base text-primary-500" aria-hidden="true" />
                      <span className="flex-1 text-sm font-medium text-foreground-800">{row.name}</span>
                      <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-bold text-secondary-800">
                        {row.type}
                      </span>
                      <span className="hidden text-xs text-foreground-500 sm:inline">{row.time}</span>
                      <span className="hidden gap-1.5 md:flex">
                        {row.files.map((file) => (
                          <span
                            key={file}
                            className="rounded border border-background-300 px-1.5 py-0.5 text-[10px] font-semibold text-foreground-600"
                          >
                            {file}
                          </span>
                        ))}
                      </span>
                    </li>
                  ))}
                </ul>

                <div className="mt-3 flex flex-wrap items-center justify-between gap-2 rounded-md bg-background-100 px-4 py-3 text-xs text-foreground-600">
                  <span>
                    Bugün <strong className="text-foreground-900">{dentistReportRows.length} rapor</strong>
                  </span>
                  <span>
                    DICOM <strong className="text-foreground-900">3</strong>
                  </span>
                  <span>
                    Ort. <strong className="text-foreground-900">~22 dk</strong>
                  </span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      <div
        className="h-px w-full bg-gradient-to-r from-transparent via-accent-500/40 to-transparent"
        aria-hidden="true"
      />
    </section>
  );
}